// extracted by mini-css-extract-plugin
module.exports = {"mask":"mask-3BMLJHyD","box":"box-1pZSPyeN","close":"close-280M1A5o","page":"page-1vTQpVJA"};